import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Toggle, notify } from 'app/components';
import { BellRinging } from '@phosphor-icons/react';
import { enableTicketAlerts, disableTicketAlerts } from '../api';
import useLoginModal from '../../login/useLoginModal';
import './style'
import { analyticEventLogger } from '../../../utils/commonUtils';
import { EVENT_NOTIFIER_SUBSCRIBE_EVENT_CLICK, EVENT_NOTIFIER_UNSUBSCRIBE_EVENT_CLICK } from '../../../constants/eventLogger';

const TicketAlert = ({ eventData }) =>{
  const [checked, setChecked] = useState(false);
  const loginModal = useLoginModal();

  const { userData } = useSelector((state) => state.app);

  useEffect(() => {
    setChecked(eventData?.alertToggle);
  }, [eventData?.alertToggle]);

  const toggleAlert = () => {
    if(!checked) {
      enableTicketAlerts(
        eventData?._id,
        () => {
          notify('success', 'Ticket alerts are enabled');
          setChecked(!checked);
        },
        () => notify('error', 'Failed to enable ticket alerts'),
      );
    } else {
      disableTicketAlerts(
        eventData?._id,
        () => {
          notify('success','Tickets alerts are disabled');
          setChecked(!checked);
        },
        () => notify('error', 'Failed to disable ticket alerts'),
      );
    }
  };

  const handleToggle = async () => {
    analyticEventLogger(checked ? EVENT_NOTIFIER_UNSUBSCRIBE_EVENT_CLICK : EVENT_NOTIFIER_SUBSCRIBE_EVENT_CLICK, {
      isAuthenticated: !!userData?.email,
    });
    if (!userData?.email) {
      loginModal.onOpen();
      loginModal.callback.current = toggleAlert;
    } else toggleAlert();
  };
  return (
    <div className='w-full flex gap-2 bd-2 p-5'>
      <BellRinging size={32}
        color='#FF2459'
        weight='fill'/>
      <div className='flex flex-col gap-2'>
        <p className='alertLabel'>
                    Ticket Alerts
        </p>
        <p className='text-14 md:text-16 text-[#717171]'>
                    Be the first to know when a ticket becomes available
        </p>
      </div>
      <Toggle className='ml-auto self-center' 
        onClick={handleToggle} 
        checked={checked}
      />
    </div>
  )
}

export default TicketAlert;